export default __webpack_public_path__ + "static/media/kaiko1.9e99c62f.png";